import { render } from "./StockTableXQ.vue?vue&type=template&id=46ea12b2&scoped=true"
import script from "./StockTableXQ.vue?vue&type=script&lang=js"
export * from "./StockTableXQ.vue?vue&type=script&lang=js"

import "./StockTableXQ.vue?vue&type=style&index=0&id=46ea12b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46ea12b2"]])

export default __exports__